import { XCircleIcon } from '@heroicons/react/outline'
import { has, isBoolean, isString, pick } from 'lodash'
import Link from 'next/link'
import { useEffect, useState } from 'react'
import {
    isCheckoutPage,
    showItemData,
    excludedItemDataList,
    shouldHideDuplicatedLineItemMeta,
} from '../../helpers/checkout'
import { canNotDelete, logoField } from '../../helpers/slug'
import {
    formatCurrency,
    formatNumberLocal,
    formatPrice,
    servicesProducts,
    subscriptionsProducts,
} from '../../helpers/utils'
import slugify from 'slugify'
import { Primary } from '../Buttons/Primary'
import { useRouter } from 'next/router'

const Wrapper = ({ children }) => (
    <div className="w-full text-left flex flex-wrap items-top gap-2">
        {children}
    </div>
)
const Left = ({ children }) => (
    <div className="flex-grow">
        <div className="max-w-lg">{children}</div>
    </div>
)
const Right = ({ children }) => (
    <div className="flex items-center justify-end gap-1">{children}</div>
)

// const getNumber = (precision) => {
//     return Number('1' + '0'.repeat(precision))
// }

// const getCampaignPrice = (rawPrices) => {
//     return formatPrice(rawPrices.price / getNumber(rawPrices.precision), 3)
// }

function CartSingleItem({ item, isAddOn, handleRemove, handleCheckout }) {
    const router = useRouter()

    let { quantity, prices } = item
    const [props, setProps] = useState({})
    const [allProps, setAllProps] = useState({})

    // console.log('CartSingleItem', item)

    item.slug = slugify(String(item.name).toLocaleLowerCase())

    const link = servicesProducts.some((service) =>
        item.permalink.includes(service.href),
    )
        ? '/service' + item.permalink.split('product')[1]
        : subscriptionsProducts.some((subscription) =>
              item.permalink.includes(subscription.href),
          )
        ? '/subscription' + item.permalink.split('product')[1]
        : '/product' + item.permalink.split('product')[1]

    // const rawPrices = prices?.raw_prices

    const appliedPrice = item.totals.line_subtotal / quantity / 100
    const regularPrice = formatPrice(prices.regular_price / 100)
    // const salePrice = formatPrice(prices.sale_price / 100)
    const total = formatPrice(item.totals.line_subtotal / 100)

    const showField = (files) => {
        return files.map((item, index) => {
            return (
                <span key={index} className="block text-sm text-gray-500">
                    {item.path}
                </span>
            )
        })
    }

    const showData = (key, props) => {
        return isString(props[key]) || isBoolean(props[key]) ? (
            <div>
                <b>{changeNameToShow(key)}</b>
                {/* <span> - {String(props[key])}</span> */}
                {' - '}
                <span>{showItemData(key, props[key], allProps)}</span>
            </div>
        ) : typeof props[key] === 'object' ? (
            <div>
                <b>{key}</b>
                {Array.isArray(props[key]) ? (
                    showField(props[key])
                ) : (
                    <span> - {props?.[key]?.name} </span>
                )}
            </div>
        ) : null
    }

    const handleAddonProducts = () => {
        let items = {}

        if (!has(item, 'item_data')) return null

        for (const _item of item.item_data) {
            items[_item.name] = _item.value
        }

        let data = { ...items }

        // Convert object to array
        let arr = Object.entries(data)

        // Sort the array
        arr.sort((a, b) => {
            let mailerTypeNumberA = parseInt(a[0].replace('Mailer Type ', ''))
            let mailerTypeNumberB = parseInt(b[0].replace('Mailer Type ', ''))
            if (isNaN(mailerTypeNumberA) || isNaN(mailerTypeNumberB)) {
                return a[0].localeCompare(b[0])
            } else {
                return (
                    mailerTypeNumberA - mailerTypeNumberB ||
                    a[0].localeCompare(b[0])
                )
            }
        })

        // Convert array back into object
        let sortedData = Object.fromEntries(arr)

        const includedProps = Object.keys(sortedData).filter(
            (key) =>
                !excludedItemDataList.includes(key) &&
                !shouldHideDuplicatedLineItemMeta({
                    lineItemName: item.name,
                    metaKey: key,
                    metaValue: sortedData[key],
                }) &&
                (!key.endsWith('Template') || key.includes('Select Template')),
        )

        setAllProps(sortedData)

        setProps(pick(sortedData, includedProps))
    }

    const changeNameToShow = (key) => {
        const alteredNameObj = {
            [logoField.name]: 'Uploads',
        }

        if (alteredNameObj[key]) {
            return alteredNameObj[key]
        }

        // this is specially for MultiTouch Logos
        if (key.includes(logoField.name)) {
            return key.replace('Logo', 'Uploads')
        }

        return key
    }

    useEffect(() => {
        handleAddonProducts()
    }, [item])

    return (
        <Wrapper>
            <Left>
                <div
                    className={`flex space-x-2 items-center ${
                        isAddOn ? 'text-sm' : 'text-lg font-semibold'
                    } text-gray-800`}>
                    {isAddOn ? (
                        <div className="space-x-2 flex items-center my-1">
                            <p>{item.name}</p>
                            {!canNotDelete(item) && (
                                <button
                                    type="button"
                                    onClick={() => handleRemove(item.key)}
                                    className="flex items-center text-sm text-gray-400 hover:text-olh">
                                    <XCircleIcon className="text-red-500 w-5 h-5 mr-1" />
                                </button>
                            )}
                        </div>
                    ) : link.includes('credit') ? (
                        <span>{item.name}</span>
                    ) : (
                        <Link href={link}>
                            <a>{item.name}</a>
                        </Link>
                    )}
                </div>
                {Object.keys(props).map((key, index) => (
                    <div
                        key={index}
                        className="block text-sm space-x-1 w-[250px]">
                        {showData(key, props)}
                    </div>
                ))}
            </Left>
            <Right>
                <span className="block truncate text-sm text-gray-500 w-20 text-right">
                    {formatCurrency(regularPrice, 3) !=
                    formatCurrency(appliedPrice, 3) ? (
                        <>
                            <span className="line-through">
                                {formatCurrency(regularPrice, 3)}
                            </span>
                            <br />
                            <span>{formatCurrency(appliedPrice, 3)}</span>
                        </>
                    ) : (
                        <span>{formatCurrency(appliedPrice, 3)}</span>
                    )}
                </span>
                <span className="p-0 text-right border-0 bg-transparent outline-none focus:outline-none focus:ring-0 w-20 text-sm block truncate text-gray-500">
                    {formatNumberLocal(quantity)}
                </span>
                <span className="block truncate text-gray-800 font-semibold text-sm w-20 text-right">
                    <span>{formatCurrency(total, 3)}</span>
                </span>
                {!isAddOn && !isCheckoutPage(router) && (
                    <span className="block truncate text-gray-800 font-semibold text-sm w-28 text-right">
                        <Primary onClick={handleCheckout}>Checkout</Primary>
                    </span>
                )}
            </Right>
        </Wrapper>
    )
}

export default CartSingleItem
